var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-cascader',{style:({ width: _vm.width }),attrs:{"options":_vm.items,"props":{
    label: 'name',
    value: 'tag_id',
    lazy: true,
    lazyLoad: _vm.load
  },"change-on-select":_vm.selectParent,"clearable":_vm.clearable,"placeholder":"请选择","size":_vm.size},on:{"change":_vm.onChange},model:{value:(_vm.currentValue),callback:function ($$v) {_vm.currentValue=$$v},expression:"currentValue"}})
}
var staticRenderFns = []

export { render, staticRenderFns }